<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { onMounted, ref, defineProps } from 'vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench } from '@/utils';
import axios from 'axios';

const props = defineProps<{
    userId: number
}>();
const walletInfos = ref({
    solde: 0,
    solde_percent: 0,
    utilise: 0,
    utilise_percent: 0,
    dernier_decaissement: 0,
    dernier_decaissement_percent: 0,
    dernier_decaissement_date: null as string | null,
});
const walletLoading = ref(false);

onMounted(() => {
    loadWalletInfos();
});

async function loadWalletInfos() {
    if (!props.userId) return;
    walletLoading.value = true;
    try {
        const response = await axios.get(`/backoffice/users/${props.userId}/wallet_infos`);
        walletInfos.value = response.data || walletInfos.value;
    } catch (error: any) {
        console.error('Erreur chargement wallet infos:', error);
    } finally {
        walletLoading.value = false;
    }
}

</script>
<template>
    <div class="s20 widget px-6 pt-8 pb-2">
        <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
            <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                Wallet / Utilisation
            </span>
        </div>
        <div class="s10 mt--5-5 flex-right">
            <button class="btn lg py-3 white2 active">
                <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                <span>Utilisation</span>
            </button>
        </div>

        <div class="s20 gap-6 px-5 pb-8 collapse-content active">
            <div class="clear-both h-10"></div>
            <div v-if="walletLoading" class="text-center py-5 text-grey-500">
                Chargement du wallet...
            </div>
            <div v-else class="flex items-center gap-6">
                <div class="s7">
                    <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                        <div class="circle-medium bg-color-1000"></div>
                        Solde
                    </h5>
                    <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(walletInfos.solde) }} F</h1>
                    <h5 class="secondary-font font-semibold text-grey-700 mb-4">{{ walletInfos.solde_percent }}%</h5>
                    <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" :style="`width: ${walletInfos.solde_percent}%;`">
                            {{ walletInfos.solde_percent }}%
                        </div>
                    </div>
                </div>
                <div class="s7">
                    <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                        <div class="circle-medium bg-purple"></div>
                        Montant Utilisé
                    </h5>
                    <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(walletInfos.utilise) }} F</h1>
                    <h5 class="secondary-font font-semibold text-grey-700 mb-4">{{ walletInfos.utilise_percent }}%</h5>
                    <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white" :style="`width: ${walletInfos.utilise_percent}%;`">
                            {{ walletInfos.utilise_percent }}%
                        </div>
                    </div>
                </div>
                <div class="s6">
                    <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                        <div class="circle-medium bg-green-light"></div>
                        Dernier décaissement
                    </h5>
                    <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(walletInfos.dernier_decaissement) }} F</h1>
                    <h5 class="secondary-font font-semibold text-grey-700 mb-4">{{ walletInfos.dernier_decaissement_percent }}%</h5>
                    <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light" :style="`width: ${walletInfos.dernier_decaissement_percent}%;`">
                            {{ walletInfos.dernier_decaissement_percent }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>